import { cloneDeep } from 'lodash'

import * as actions from './PlayerDetailsActions'

export default (state = actions.PLAYER_DETAILS_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case actions.PLAYER_DETAILS_FETCH: {
      return {
        ...cloneDeep(actions.PLAYER_DETAILS_INITIAL_STATE),
        id: action.payload.playerId,
        loading: true,
        tournamentId: action.payload.tournamentId,
      }
    }
    case actions.PLAYER_DETAILS_FETCH_CANCELED: {
      return cloneDeep(actions.PLAYER_DETAILS_INITIAL_STATE)
    }
    case actions.PLAYER_DETAILS_FETCH_ERROR: {
      return {
        ...cloneDeep(state),
        id: null,
        error: action.payload,
        loading: false,
        tournamentId: null,
      }
    }
    case actions.PLAYER_DETAILS_FETCH_FULFILLED: {
      return {
        ...cloneDeep(state),
        ...action.payload,
        loading: false,
      }
    }

    default:
  }
  return state
}
